import React from "react";
import __ from "src/utils/Translations";
import { isNull, isEmpty } from "lodash";

const getBenefitPerson = ({ beneficiaryFirstName, beneficiaryLastName }) =>
  beneficiaryFirstName !== "-" && beneficiaryLastName !== "-"
    ? `${__("dla")} ${
        isEmpty(beneficiaryFirstName) && isEmpty(beneficiaryLastName)
          ? "..."
          : `${beneficiaryFirstName} ${beneficiaryLastName}`
      }`
    : "";

const BenefitNameColumn = (cellInfo) => {
  const benefitName = cellInfo.row[cellInfo.column.id];
  const beneficiaryPerson = getBenefitPerson(cellInfo.original);

  return (
    <span className="text-break text-center">
      <strong>{benefitName} </strong>
      {beneficiaryPerson}
    </span>
  );
};

export default BenefitNameColumn;
